import { render, staticRenderFns } from "./ViewSaved.vue?vue&type=template&id=58393714&"
import script from "./ViewSaved.vue?vue&type=script&lang=js&"
export * from "./ViewSaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports